<script setup>
import { onMounted, watch } from 'vue';
import { useCasinoGamesStore } from '~/stores/casino-games';

const casinoGamesStore = useCasinoGamesStore();



const fetchData = () => {
  casinoGamesStore.resetFilters();
  casinoGamesStore.getSlots();
};

onMounted(() => {
  fetchData();
});
</script>

<template>
  <div class="flex flex-col gap-4">
    <!-- Using the reusable Legitimuz component -->
    <LegitimuzElements />

    <!-- Filtro dos jogos de Cassino-->
    <CasinoFilters :param="1" />

    <CasinoHeader />

    <!-- Exibição dos jogos de cassino -->
    <CasinoGames :games="casinoGamesStore.games" :is-loading="casinoGamesStore.state.isLoading" />

    <!-- Paginação dos jogos de cassino -->
    <CasinoPagination />
  </div>
</template>